// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"877c3203","190":"1b5f2c8c","296":"113d4c26","415":"7f9688bb","491":"ff333742","552":"6867d83a","830":"e06c1d38"}[chunkId] + ".chunk.css";
};